import { Box, Button, Flex, Heading, Image, Text } from '@everlywell/ui-kit';
import React from 'react';

interface ICtaBanner {
  logo?: {
    file: {
      url: string;
    };
  };
  backgroundImage?: {
    file: {
      url: string;
    };
  };
  bannerHeading?: string;
  ctaHeading?: string;
  cta?: {
    url: string;
    label: string;
  };
  mobileBackgroundImage?: {
    file: {
      url: string;
    };
  };
  text?: string;
}

export const CtaBanner: React.FC<ICtaBanner> = ({
  backgroundImage,
  ctaHeading,
  cta,
  mobileBackgroundImage,
  logo,
  text,
}) => (
  <Box
    bg="#f0f4f8"
    pt={['0rem', '6rem', '7rem']}
    pb={['22rem', '6rem', '7rem']}
    pl={['0', '1rem']}
    overflow="hidden"
    backgroundImage={`url(${backgroundImage?.file?.url})`}
    sx={{
      '@media screen and (max-width: 48em)': {
        backgroundImage: `url(${mobileBackgroundImage?.file?.url})`,
      },
    }}
    backgroundSize="cover"
    backgroundPosition="50%"
    position="relative"
    data-testid="cta-banner"
  >
    <Box maxWidth="1440px" mx="auto">
      <Box
        p={['1.2rem', '2.5rem']}
        bg="white"
        borderRadius="0.75rem"
        display="flex"
        flexDirection="column"
        gap={['1.5rem', '2.5rem']}
        width="100%"
        maxWidth={['600px', '500px']}
        alignItems={['center', 'flex-start']}
      >
        {logo && (
          <Image
            src={logo?.file?.url}
            alt="logo"
            maxWidth="220px"
            width="100%"
          />
        )}

        <Flex
          direction="column"
          gap="0.75rem"
          alignItems={['center', 'flex-start']}
        >
          <Heading
            maxWidth="419px"
            color="#012b3b"
            fontSize={['2rem', '2.2rem']}
            lineHeight={['2.5rem', '2.8rem']}
            fontFamily="heading"
            fontWeight="400"
            textAlign={['center', 'left']}
          >
            {ctaHeading}
          </Heading>

          <Text
            maxWidth="387px"
            color="#545454"
            size="lg"
            fontWeight="400"
            lineHeight="1.6875rem"
            textAlign={['center', 'left']}
          >
            {text}
          </Text>
        </Flex>

        <Button
          as="a"
          href={cta?.url}
          target="_self"
          aria-label={cta?.label}
          height="3.25rem"
          px="1.5rem"
          bg="#012b3b"
          color="white"
          fontSize="1rem"
          fontWeight="500"
          width={['100%', 'auto']}
        >
          {cta?.label}
        </Button>
      </Box>
    </Box>
  </Box>
);
